import Enquiries from "../../../jsx/components/Dashboard/Enquiries/Enquiries";

const EnquiriesWrapper = () => {
  return <Enquiries />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.connector];

export default constore(EnquiriesWrapper);
